module.exports = __webpack_public_path__ + "media/images/secured-book-5b8b9bc2df1ef8d169f9f5ec1ade80b2.jpg";